import { NgModule } from '@angular/core';

import { ApErrorModule } from '@ap/error';
import { ApLoggingModule } from '@ap/logging';
import { ApSignComponent } from '@ap/sign';

import { MijnErrorHandler } from './mijn-error-handler';
import { MijnHttpErrorService } from './mijn-http-error.service';

/**
 * @name MijnErrorHandlerModule
 *
 * @ngdoc module
 */
@NgModule({
    providers: [MijnErrorHandler, MijnHttpErrorService],
    imports: [ApErrorModule, ApLoggingModule, ApSignComponent]
})
export class MijnErrorHandlerModule {}
